import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { GemTitle, GemText } from "./components"

const TitleSection = ({ title, text, gemRefs }) => {
  return (
    <Box contain mt={5} ref={gemRefs} textAlign="center">
      <GemTitle>{title}</GemTitle>
      <GemText>{text}</GemText>
    </Box>
  )
}

TitleSection.propTypes = {
  gemRefs: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  text: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.node,
  ]),
  title: PropTypes.string,
}

export default TitleSection
